import { MenuItem, TextField } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
//import { getSiteIconName } from "../../../../utils/CommonUtils";
//import CustomIcon from "../../CustomIcons/CustomIcon";
import classes from "../CustomInputs.module.css";
import { getIconByScope, getSiteByScopeId } from "../../../../utils/UsersUtils";

const ScopesSelectInput = (props) => {
  const sites = useSelector((state) => state.user?.sites); // added
  
  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [props.value]);

  const handleChange = (event) => {
    const { name, value } = event.target ? event.target : event;
    props.onChange({ [name]: props.list.find((scope) => scope.id === value) });
    if (props.selectScopeId) {
      props.selectScopeId(value)
    }
  };

  return (
    <div className={classes.customSelectField}>
      <TextField
        fullWidth
        select
        id={props.id}
        name={props.id}
        disabled={props.disabled}
        className={classes.textField}
        defaultValue={props.value}        
        onChange={handleChange}
        error={props.isStepSubmitted && props.hasError}
        helperText={
          props.isStepSubmitted && props.hasError ? props.errorMessage : ""
        }
        InputLabelProps={{ shrink: true }}
        InputProps={{
          classes: {
            notchedOutline: classes.filed,
          },
        }}
        FormHelperTextProps={{
          classes: {
            error: classes.error,
          },
        }}
        SelectProps={!props.disabled ? {     
          renderValue: (scopeId) => {
            let scope = props.list?.find((scope) => scope.id === scopeId);
            if (scope) {
              const site = getSiteByScopeId(sites, scope.id);
              return (
                <MenuItem>
                  {/* <CustomIcon
                    className={classes.siteIcon}
                    iconName={getSiteIconName(getSiteByScopeId(sites, scope.id) ? getSiteByScopeId(sites, scope.id).clientId : 1)}
                  /> */}
                  {getIconByScope(sites, scope, classes.siteIcon)}
                  <div className={classes.cardInfo}>
                    <span className={classes.siteName}>{site ? site.displayName : scope.name}</span>
                    <span className={classes.siteAddress}>{site ? site.address : null}</span>
                  </div>
                </MenuItem>      
              );
            }       
          },
          MenuProps: {
            classes: {
              list: classes.menuPaper
            },
          },
          } : {
            // when disabled, clear arrow icon,
            // disable animation on click (touch ripple), gray site icon
            IconComponent: () => null,
            renderValue: (scopeId) => {
              let scope = props.list?.find((scope) => scope.id === scopeId);
              if (scope) {
                const site = getSiteByScopeId(sites, scope.id);
                return (
                  <MenuItem disableTouchRipple={props.disabled}>
                    {/* <CustomIcon
                      className={props.disabled ? [classes.siteIcon, classes.disable].join(' ') : classes.siteIcon}
                      iconName={getSiteIconName(getSiteByScopeId(sites, scope.id) ? getSiteByScopeId(sites, scope.id).clientId : 1)}
                    /> */}
                    {getIconByScope(sites, scope, props.disabled ? [classes.siteIcon, classes.disable].join(' ') : classes.siteIcon)}
                    <div className={classes.cardInfo}>
                      <span className={classes.siteName}>{site ? site.displayName : scope.name}</span>
                      <span className={classes.siteAddress}>{site ? site.address : null}</span>
                    </div>
                  </MenuItem>      
                );
              }           
            },
            MenuProps: {
              classes: {
                list: classes.menuPaper
              },
            },
          }}
        >
        {props.list &&
          props.list.map((scope) => {
            const site = getSiteByScopeId(sites, scope.id);
            return (
              <MenuItem className={classes.customSelectField} key={scope.id} value={scope.id}>
                {/* <CustomIcon
                  className={classes.siteIcon}
                  iconName={getSiteIconName(getSiteByScopeId(sites, scope.id) ? getSiteByScopeId(sites, scope.id).clientId : 1)}
                /> */}
                {getIconByScope(sites, scope, classes.siteIcon)}
                <div className={classes.cardInfo}>
                  <span className={classes.siteName}>{site ? site.displayName : scope.name}</span>
                  <span className={classes.siteAddress}>{site ? site.address : null}</span>
                </div>
              </MenuItem>
            );
          })}
      </TextField>
    </div>
  );
};

export default ScopesSelectInput;
